import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpandAlt, faCompressAlt } from "@fortawesome/free-solid-svg-icons";
import {
  Container,
  MainContent,
  StickyHeader
} from "../../styled-components/Layout";
import { IconButton } from "../../styled-components";

const ContentListContainer = styled(Container)`
  position: relative;
  border-right: 1px solid ${props => props.theme.border};
  flex-basis: 50%;
  flex-grow: 1;
  overflow: hidden;
  -webkit-transition: min-width 0.5s ease;
  -moz-transition: min-width 0.5s ease;
  -ms-transition: min-width 0.5s ease;
  -o-transition: min-width 0.5s ease;
  transition: min-width 0.5s ease;
  min-width: 0;

  &.expanded {
    min-width: 100% !important;
    z-index: 100;
  }
`;

const ContentListHeader = styled(StickyHeader)`
  display: flex;
  position: relative;
  padding-left: 0.25rem;
  background-color: ${props => props.theme.colors.grey};
  justify-content: center;
`;

const TitleContainer = styled.div`
  margin-left: ${props => (props.expandable ? "auto" : "0")};
`;

const ContentListIconContainer = styled.div`
  margin-left: auto;
`;

const ContentListIcon = styled(IconButton)``;

const ExpandIcon = "images/expand.png";

const ContractIcon = "images/contract.png";

class ContentList extends PureComponent {
  constructor() {
    super();

    this.state = {
      expanded: false
    };
  }

  toggleExpand = () => {
    if (this.props.expandable) {
      this.setState({
        expanded: !this.state.expanded
      });
    }
  };

  render() {
    return (
      <ContentListContainer className={this.state.expanded ? "expanded" : ""}>
        <ContentListHeader>
          <TitleContainer expandable={this.props.expandable}>
            {this.props.headerText}
          </TitleContainer>
          {this.props.expandable ? (
            <ContentListIconContainer>
              <ContentListIcon onClick={this.toggleExpand}>
                <FontAwesomeIcon
                  fixedWidth
                  size="lg"
                  icon={this.state.expanded ? faCompressAlt : faExpandAlt}
                />
              </ContentListIcon>
            </ContentListIconContainer>
          ) : (
            ""
          )}
        </ContentListHeader>
        {this.props.children}
      </ContentListContainer>
    );
  }
}

ContentList.defaultProps = {
  children: {},
  headerText: "",
  expandable: false
};

ContentList.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  headerText: PropTypes.string,
  expandable: PropTypes.bool
};

export default ContentList;



// WEBPACK FOOTER //
// ./app/components/ContentSelection/ContentList.js